export class ApiSubstatus {
    public id: number | null;
    public api_status_id: number;
    public app_status_id: number;
    public name: string;
    public description: string;

    constructor(data: ApiSubstatusData | void) {
        if (data === undefined) {
            this.id = null;
            this.api_status_id = 0;
            this.app_status_id = 0;
            this.name = '';
            this.description = '';
        } else {
            this.id = data.id;
            this.api_status_id = data.api_status_id;
            this.app_status_id = data.app_status_id;
            this.name = data.name;
            this.description = data.description ? data.description : '';
        }
    }

    public resetToDefaults(): void {
        this.id = null;
        this.api_status_id = 0;
        this.app_status_id = 0;
        this.name = '';
        this.description = '';
    }

    public serializeData():ApiSubstatusData {
        return {
            id: this.id,
            api_status_id: this.api_status_id,
            app_status_id: this.app_status_id,
            name: this.name,
            description: this.description,
        }
    }
}

export type ApiSubstatusData = {
    id: number | null;
    api_status_id: number;
    app_status_id: number;
    name: string;
    description: string;
}